// extracted by extract-css-chunks-webpack-plugin
module.exports = {"center_box":"center_box-2ghWH00s","dbox":"dbox-2QwibS2i"};